import React from "react";
import * as styles from "./portfolio.module.css";

interface PortfolioHeroProps {
  className?: string;
  stats?: string[];
  liveTrackingText?: string;
}

const defaultStats = [
  "20+ | Countries Served",
  "150+ | Products Delivered",
  "10M+ | User Reach",
  "8+ | Years of Excellence",
];

const splitStat = (value: string): { number: string; label: string } => {
  const withPipe = value
    .split("|")
    .map((v) => v.trim())
    .filter(Boolean);
  if (withPipe.length >= 2) {
    return { number: withPipe[0], label: withPipe.slice(1).join(" | ") };
  }

  const parts = value.trim().split(" ");
  if (parts.length === 1) {
    return { number: parts[0], label: "" };
  }
  return { number: parts.shift() || "", label: parts.join(" ") };
};

export const PortfolioHero: React.FC<PortfolioHeroProps> = ({
  className = "",
  stats = defaultStats,
  liveTrackingText = "Currently building 12 products for clients in 4 time zones",
}) => {
  const parsedStats = stats.length > 0 ? stats.slice(0, 4) : defaultStats;

  return (
    <section className={`${styles.heroSection} text-center ${className}`}>
      <div className="container">
        {/* <h1 className="display-4 font-weight-bold mb-5">Our Portfolio</h1> */}

        <div className="row mb-4 justify-content-center">
          {parsedStats.map((stat, idx) => {
            const { number, label } = splitStat(stat);
            return (
              <div className="col-6 col-md-3 mb-4" key={`${stat}-${idx}`}>
                <div className={styles.statsNumber}>{number}</div>
                <div className={styles.statsLabel}>{label}</div>
              </div>
            );
          })}
        </div>

        <div className="mb-4">
          <div className={styles.liveTicker}>
            <div className={styles.pingDot}>
              <span></span>
              <span></span>
            </div>
            {liveTrackingText}
          </div>
        </div>
      </div>
    </section>
  );
};
